module.exports = __webpack_public_path__ + "static/img/far2_active.e7344167.png";